import axios from 'axios';
import { store } from '../index';
import { serverError, invalidUser, fetchSecurityQuestion, logoutUser, setSuccessMessage, incrementSessionRefreshTimer } from '../actions/index';
import { getSubPath } from '../config/config';

const subPath = getSubPath(window.location.pathname);
const baseURL = subPath;
const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Pragma: 'no-cache',
};

export const axiosInstance = axios.create({
    baseURL: baseURL,
    headers: headers,
});

axiosInstance.interceptors.request.use(
    (conf) => {
        console.log('Logging Request from Interceptor', conf);
        console.log('Logging state from request interceptor', store.getState());
        let globalstate = store.getState();
        console.log('Email ID is', globalstate.beneDetails.details.emailId);
        if (process.env.NODE_ENV === 'development') {
            conf.headers['X-Bene-user-id'] = globalstate.beneDetails.details.emailId;
          
        }
        console.log('Logging captchaToken from Interceptor', globalstate.beneDetails.captchaToken);

        conf.headers['X-HSBC-ReCaptcha-Response'] = globalstate.beneDetails.captchaToken;
        return conf;
    },
    (error) => {
        return Promise.reject(error);
    }
);
axiosInstance.interceptors.response.use(
    (next) => {
        console.log(`Intercepting ${next.config.url} success response`, next);
        try {
            console.log('About to dispatch incrementSessionRefreshTimer() action');
            store.dispatch(incrementSessionRefreshTimer());
        } catch (e) {
            console.error('e after dispatch is', e);
        }

        if (next.config.url === '/bsmapi/api/v1/users/passwordreset') {
            if (next.status === 200) {
                let data = {
                    status: next.status,
                    statusText: 'Password has been reset successfully.',
                };
                try {
                    store.dispatch(setSuccessMessage(data));
                } catch (e) {
                    console.error(`Logging store.dispatch(setSuccessMessage(data)) error`, e);
                }
            }
            console.log('Intercepted password reset success response ', next);
        }
        console.log('TIMEOUT | Sending success response back to the React component');
        return Promise.resolve(next);
    },
    (error) => {
        console.log('Logging Error response from Interceptor', error);
        if (error && error.response && error.response.status === 401) {
            console.error('Intercepting 401 error ', error.response);

            // User has been soft locked, remove the EDOSI JSX and reset security question
            if (error.response.data.errorCode === 'USER_LOGIN_ERROR_008') {
                try {
                    store.dispatch({ type: 'RESET_SECURITY_QUESTION', payload: { id: null, qid: null, question: null } });
                } catch (e) {
                    console.error(
                        `Logging store.dispatch({ type: 'RESET_SECURITY_QUESTION', payload: { id: null, qid: null, question: null } }) error`,
                        e
                    );
                }
            }

            // User entered incorrect password too many times, Call API to fetch security question
            if (error.response.data.errorCode === 'USER_LOGIN_ERROR_006') {
                try {
                    let userSecurityResponse = error.response.data.userSecurityResponse;
                    let securityQuestion = {
                        id: userSecurityResponse.id,
                        question: userSecurityResponse.question,
                    };
                    store.dispatch(fetchSecurityQuestion(securityQuestion));
                } catch (e) {
                    console.error('Logging store.dispatch(fetchSecurityQuestion()) error', e);
                }
            }

            console.log('error.response.config.url is', error.response.config.url);
            let urlFromConfig = error.response.config.url;
            let requestNotFromLoginPage = urlFromConfig.includes('authenticate');
            if (requestNotFromLoginPage) {
                console.log('Request is not for Login');
            } else {
                console.log('Request is for Login');
            }

            // If 401 is dispatched from Authenticate API then dispatch invalidUser
            // Else dispatch logoutUser
            if (requestNotFromLoginPage) {
                try {
                    // invalidUser() action is dispatched when user enters incorrect credentils from login page
                    store.dispatch(invalidUser(error.response.data));
                } catch (e) {
                    console.error('Logging error store.dispatch(invalidUser(error.response.data))', e);
                }
            } else {
                let data = {
                    status: error.response.data.status,
                    message: error.response.data.message,
                };
                try {
                    store.dispatch(logoutUser(data));
                } catch (e) {
                    console.error('Logging store.dispatch(logoutUser(data)) error', e);
                }
            }
        }

        // Restarting the Session timeout timer
        try {
            console.log('About to dispatch incrementSessionRefreshTimer() action');
            store.dispatch(incrementSessionRefreshTimer());
        } catch (e) {
            console.error('e after dispatch is', e);
        }

        // There has been a server error
        if (error && error.response.status.toString().charAt(0) === '5') {
            let status = error.response.status;
            let statusText = 'Internal Server Error';
            let data = {
                status,
                statusText,
            };
            try {
                store.dispatch(serverError(data));
            } catch (e) {
                console.error('Logging store.dispatch(serverError(data)) error', e);
            }
        } else throw error;
    }
);
